import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import {
  AssistMigrationDistributionPreview,
  AssistMigrationExecuteResult,
} from 'types/assist/assistMigration';

interface ExecuteAssistMigrationResponse {
  success: boolean;
  data: AssistMigrationExecuteResult;
}

export const executeAssistMigration = (
  businessId: number,
  distribution?: AssistMigrationDistributionPreview | null,
): AxiosPromise<ExecuteAssistMigrationResponse> =>
  httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/assist/migration/execute`,
    data: distribution
      ? {
          distribution: {
            businessSettings: distribution.businessSettings,
            global: distribution.global,
            stores: distribution.stores,
          },
        }
      : {},
  });
